<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">武侠管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <edit-config @refresh="getProjectList"></edit-config>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import List from './components/List';
import Create from './components/Create';
import EditConfig from './components/EditConfig';
// import Settle from './components/Settle';

export default {
  name: 'leagueMain',
  data() {
    return {};
  },
  components: {
    List,
    Create,
    EditConfig
    // Settle
  },
  methods: {
    ...mapActions('league', ['getList']),
    getProjectList(data = {}) {
      this.getList();
    }
  },
  created() {
    this.getProjectList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
